import { GoogleplaceDirective } from './../../plugins/googleaddressautocomplete/google-address-autocomplete';
import { IKeyValueInterface, Marker, IDropDownInterface, RoleLevel } from './../../shared/config';
import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { OdometerLogTrailModel } from '../models/odometerlogtrail.model';
import { OdometerLogTrailService } from '../models/odometerlogtrail.service';
import { VehicleService } from './../../vehicle/models/vehicle.service';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, PermissionType } from '../../shared/config';
import { Location } from '@angular/common';
import { FlatPickrModel } from "../../plugins/flatpickr/flatpickr.model";
import { DropdownModel } from '../../report/models/report-filter.model';

@Component({
  selector: 'wego-odometerlogtrail',
  template: require('../views/odometerlogtrail-update.component.html'),
  providers: [OdometerLogTrailService, VehicleService],
})
export class OdometerLogTrailUpdateComponent implements OnInit {
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = WeGoConfig.GRID_MAX_PAGE_SIZE;
  public itemsPerPage: number = WeGoConfig.GRID_MAX_DATA_SIZE;
  private odometerLogHashId: string;
  private sub: any;
  model: OdometerLogTrailModel;
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  message: string;
  vehicleList: DropdownModel[];
  isEditMode: boolean = false;
  flatPickrConfigDateTimePicker: FlatPickrModel;
  pageName : string;

  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;

  public searchField: string = "";
  public searchTerm: string = "";


  urlDefaultPage: string;
  urlOdometerLogTrailList: string;
  roleLevel = RoleLevel;

  @ViewChild('successPopup') public successPopup: any;


  constructor(private odometerLogTrailService: OdometerLogTrailService,
    private translate: TranslateService, private vehicleService: VehicleService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router, private locationService: Location) {
  }

  ngOnInit() {
    this.pageName = "OdometerLogTrail";
    this.module = this.translate.instant('LblOdometerLogTrail');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlOdometerLogTrailList = this.authService.GetURL(ApplicationRouteURL.URL_ODOMETERLOGTRAIL_LIST);
    this.flatPickrConfigDateTimePicker = this.SetDefaultFlatPickrConfig();
    this.model = new OdometerLogTrailModel();
    this.GetOdometerLogTrailDetail();
  }

  private SetDefaultFlatPickrConfig(isDateOnly?: boolean) {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = !isDateOnly ? true : false;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.maxDate = new Date(new Date().setHours(0, 0, 0));
    flatPickrConfig.dateFormat = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public GetOdometerLogTrailDetail() {
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.odometerLogHashId = params['id'] || '';
        if (this.odometerLogHashId != '') {
          this.isEditMode = true;
          this.odometerLogTrailService.GetOdometerLogTrailByHashId(this.odometerLogHashId)
            .subscribe(
            res => {
              this.model = res.data;
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
            });
        }
        else {
          this.isEditMode = false;
          this.model = new OdometerLogTrailModel();
          this.GetVehicleList(PermissionType.INSERT);
        }
      });
    this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
  }

  onSubmit(forms: any) {
    console.log(this.model);
    this.AddOdometerLogTrail();
  }
  public AddOdometerLogTrail() {
    this.odometerLogTrailService.AddOdometerLogTrail(this.model)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.isEditMode ? this.translate.instant('LblRecordUpdatedSuccess', [this.module]) : this.translate.instant('LblRecordAddedSuccess', [this.module]);
          this.ShowSuccessPopup();
        }
        else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      });
  }
  public GetVehicleList(permissionType : string) {
    this.odometerLogTrailService.GetVehicleDropdownForOdometer(permissionType)
      .subscribe(
      res => {
        this.vehicleList = res.data;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      });
  }
  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }
  public OnBackClick() {
    this.locationService.back();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/odometerlogtrail/components/odometerlogtrail-update.component.ts